// extracted by mini-css-extract-plugin
export var label = "bG_fN";
export var row = "bG_fM";
export var value = "bG_fP";
export var wrapper = "bG_bF";